import React from "react";

import { mdiCurrencyUsd } from "@mdi/js";
import Icon from "@mdi/react";

import type { JSX } from "react";

export default function AdbreakRuleIcon(): JSX.Element {
  return (
    <div className="bg-primary/10 overflow-hidden rounded-full">
      <Icon className="text-primary p-1.25" path={mdiCurrencyUsd} size={1.25} />
    </div>
  );
}
